
import gql from 'graphql-tag'
import userFavProductWLProtection from '@/apollo/queries/user/userFavProductWLProtection'
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment'
import wlProtectionTooltips from '~/apollo/queries/product/tooltips/wlProtectionTooltips'
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: "FavProductSaving",
  mixins: [productPromotionMixins, productInsuranceNameMixins],
  data: () => ({
    product: Object,
    productLoading: 0,
    currentLink: "",
  }),
  props: {
    productId: String,
    params: String,
    favProductId: String,
  },
  apollo: {
    product: {
      prefetch: true,
      loadingKey: "productLoading",
      query: gql`${userFavProductWLProtection} ${productPromotionFragment}`,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);

        console.debug("fav product query vars:");
        console.debug(returnObj);

        return returnObj;
      },
      update(data) {
        return data?.savingPlanScenarios?.data;
      },
      result({ data }) {
        // console.debug(JSON.stringify(data));
      },
    },
    tooltips: {
      query: wlProtectionTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).WLProtection;
      },
    },
  },
  computed: {
    simpleItem() {
      if (!this.productLoading) {
        if (this.product) {
          return this.product.map((item) => {
            const planName = item.attributes.saving_plan.data.attributes.saving_plan_translations.data[0].attributes.name;
            const insurer = item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
            const link = this.currentLink;
            let promotions = null;
            let promotion = null;
            let promotion_last_call = null;

            let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.protection.pt_categoryName'), insurer, planName, { page: this.$route.name?.split('__')[0], link: link });
            let decoderCTAText = '';
            
            // check scenario level promo first , then plan level promotion 
            if (item.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.saving_plan.data.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.saving_plan.data.attributes.product_promotions.data;
            }
            
            if(promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotion_last_call = this.checkPromotionLastCall(promotion);

              if (!promotion) {
                promotion = null;
              }
              else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                decoderCTALink =
                  promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                decoderCTAText = this.$t('products.product_website');
              }

            }

            const filteredTranslations = this.getFilteredTranslations(item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data);

            return {
              scenario_code: item.attributes.scenario_code,
              payment_terms: item.attributes.payment_terms,
              pre_pay: item.attributes.pre_pay,
              currency: item.attributes.currency.data.attributes.currency_translations.data[0].attributes,
              currency_code: item.attributes.currency.data.attributes.code,
              lifeprotection_score: item.attributes.lifeprotection_score,
              overall_star_protection: item.attributes.overall_star_protection,

              death_g_tot_avg_0_19: item.attributes.death_g_tot_avg_0_19,
              death_g_tot_avg_20_49: item.attributes.death_g_tot_avg_20_49,
              total_premium: item.attributes.total_premium,
              // plan
              plan_name: planName,

              // insurer
              insurer_name_first:
                item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .insurance_company_translations.data[0].attributes.name,
              insurer_name_second:
                filteredTranslations[0].attributes.name,
              insurer_logo:
                item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .logo,
              insurer_code:
                item.attributes.saving_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                  .code,

              // financial details
              policy_year: item.attributes.saving_plan_financial_details.data[0].attributes.policy_year,
              scenarioID: item.id,
              product_promotion: promotion,
              promotion_last_call: promotion_last_call,

              decoder_cta_link: decoderCTALink,
              decoder_cta_text: decoderCTAText,
            };
          })[0];
        }
      }
      return null;
    },

    displayProduct() {
      if (this.simpleItem) {
        const item = this.simpleItem;
        return {
          favProductId: this.favProductId,
          id: item.scenario_code,
          category: this.category,
          productType: "whole-life-protection",
          scenarioId: item.scenarioID,
          showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star_protection),
          showTrending: false,
          productLink: this.$extendPath('/products/whole-life-protection', '/' + item.scenario_code),
          productName: item.plan_name,
          insuranceCompany: {
            name: item.insurer_name_first + ' | ' + item.insurer_name_second,
            code: item.insurer_code,
            logoSrc: item.insurer_logo?.data?.attributes.url,
            logoAlt: item.insurer_name_first,
          },
          userRating: {
            score: item.overall_star_protection,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.$formatScore(item.lifeprotection_score)),
            description: this.$t('products.protection.pt_wholeLifeProtectionScore'),
            toolTipHtml: this.getTooltipContentByKey('pt_wholeLifeProtectionScore'),
          },
          features: [
            {
              text: item.pre_pay
                ? this.$t('products.longSavings.ls_prepaid')
                : item.payment_terms + this.$t('products.protection.pt_yearpayment'),
              type: 'payment_term',
            },
            {
              text: this.getCurrency(item.currency),
              type: 'currency',
            },
          ],
          keyItems: [
            {
              value: this.$formatPrice(item.death_g_tot_avg_0_19),
              key: this.$t('products.protection.pt_age35_54AverageDeathBenefit'),
              topSubText: item.currency_code,
              toolTipHtml: this.getTooltipContentByKey('pt_age35_54AverageDeathBenefit'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatPrice(item.death_g_tot_avg_20_49),
              key: this.$t('products.protection.pt_age55_84AverageDeathBenefit'),
              topSubText: item.currency_code,
              toolTipHtml: this.getTooltipContentByKey('pt_age55_84AverageDeathBenefit'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatPrice(item.total_premium / item.payment_terms),
              key: this.$t('products.protection.pt_annualPremium'),
              topSubText: item.currency_code,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
          ],
          compactKeyItems: [
            {
              value: this.$formatPrice(item.death_g_tot_avg_0_19),
              key: this.$t('products.protection.pt_age35_54AverageDeathBenefit'),
              topSubText: item.currency_code,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatPrice(item.death_g_tot_avg_20_49),
              key: this.$t('products.protection.pt_age55_84AverageDeathBenefit'),
              topSubText: item.currency_code,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
          ],
          promotion: {
            category:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
            title:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: item.product_promotion?.id,
            scenarioId: item.scenarioID,
            lastCall: item.promotion_last_call

          },
          mainButtonCTA: {
            text: item.decoder_cta_text,
            link: item.decoder_cta_link,
          },
        }
      }
      return null
    },

    simpleParams() {
      let vars = Array;
      vars = [];
      const hash = this.params.split('&');

      for (let i = 0; i < hash.length; i++) {
        const params = hash[i].split("=");
        vars[params[0]] = params[1];
      }

      return vars;
    }
  },
  watch: {
    product() {
      if (this.product.length) {
        this.$emit("product-load", 'WLProtection');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  mounted() {
    this.currentLink = window.location.href;
  },
  updated() {
    if (this.simpleItem) {
      this.$emit("productTitle", { id: this.favProductId, companyName: this.simpleItem.insurer_name_first, title: this.simpleItem.plan_name });
    }
  },
  methods: {
    getCurrency(curr) {
      if (this.$normalizeLocale(this.$i18n.locale) === "zh-Hant-HK") {
        return curr.text;
      }
      else {
        return curr.localizations.data[0].attributes.text;
      }
    },

    getCurrencyCode(curr) {
      if (this.$normalizeLocale(this.$i18n.locale) === 'zh-Hant-HK') {
        return curr.code;
      } else {
        return curr.localizations.data[0].attributes.code;
      }
    },

    getStar(product) {
      if (this.simpleParams.risk_pref === 'Conservative') {
        return product.overall_star_conservative;
      }
      else if (this.simpleParams.risk_pref === 'Growth') {
        return product.overall_star_growth;
      }
      else if (this.simpleParams.risk_pref === 'Aggressive') {
        return product.overall_star_aggressive;
      }
    },

    getScore(product) {
      if (this.simpleParams.risk_pref === 'Conservative') {
        return this.$formatScore(product.conservative_savings_score);
      }
      else if (this.simpleParams.risk_pref === 'Growth') {
        return this.$formatScore(product.growth_savings_score);
      }
      else if (this.simpleParams.risk_pref === 'Aggressive') {
        return this.$formatScore(product.aggressive_savings_score);
      }
    },

    getScoreLabel() {
      if (this.simpleParams.risk_pref === 'Conservative') {
        return this.$t('products.longSavings.ls_conservativeSavingsScore');
      }
      else if (this.simpleParams.risk_pref === 'Growth') {
        return this.$t('products.longSavings.ls_growthSavingsScore');
      }
      else if (this.simpleParams.risk_pref === 'Aggressive') {
        return this.$t('products.longSavings.ls_aggressiveSavingsScore');
      }
    },

    getScoreTooltip() {
      switch (this.simpleParams.risk_pref) {
        case 'Conservative':
          return this.getTooltipContentByKey('ls_conservativeSavingsScore');

        case 'Growth':
          return this.getTooltipContentByKey('ls_growthSavingsScore');

        case 'Aggressive':
          return this.getTooltipContentByKey('ls_aggressiveSavingsScore');
      }
    },

    getTooltipContentByKey(mKey) {
      return this.tooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    unfavourite() {
      // console.debug("adpater unfav");
      this.$emit("unfavourite", this.favProductId)
    },
  },
}
